export default (previousState = 0, {type, payload}) => {
    if (type === 'RA/CRUD_CHANGE_LIST_PARAMS' && payload.filter && payload.filter.category_id) {
        return payload.filter.category_id;
    }
    if (type === '@@router/LOCATION_CHANGE' && payload.location && payload.location.pathname === '/offers' && payload.location.search == '') {
        return 0;
    }
    return previousState;
}
